/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Pos_Reminders_OverInputs */

const en_queue_pos_reminders_over = /** @type {(inputs: Queue_Pos_Reminders_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase orders not confirmed after the reminders`)
};

/**
* | output |
* | --- |
* | "Purchase orders not confirmed after the reminders" |
*
* @param {Queue_Pos_Reminders_OverInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_pos_reminders_over = /** @type {((inputs?: Queue_Pos_Reminders_OverInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Pos_Reminders_OverInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_pos_reminders_over(inputs)
});